import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DeleteIcon from '@material-ui/icons/Delete';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import AddIcon from '@material-ui/icons/Add';
import DeleteDialog from '../../Shared/Dialogs/DeleteDialog';

export default function RestrictionsOverviewDrawer(props) {
    const classes = useStyles();
    const [dialogOpen, setDialogOpen] = useState(false)
    const [restrictionId, setRestrictionId] = useState(null)
    const [dialogTitle, setDialogTitle] = useState(null)
    const [dialogContext, setDialogContext] = useState(null)

    const rows = props.workstation.restrictions.filter(x => x.type !== 4).sort((a, b) => parseFloat(a.workstation) - parseFloat(b.workstation)).map(restriction =>
        createData(restriction.workstation, restriction.start, restriction.end, restriction.type, restriction.id, restriction.id)
    )

    function createData(workstation, start, end, type, editId, deleteId) {

        let typeColor = ""
        if (type === 1) {
            typeColor = "#5CC958"
        } else if (type === 2) {
            typeColor = "#D84949"
        } else if (type === 3) {
            typeColor = "#F59128"
        }

        let typeDescription = props.workstation.restrictionTypes.find(x => x.id === type).description

        return { workstation, start, end, typeDescription, editId, deleteId, typeColor };
    }

    function deleteRestriction() {
        let tempRestrictions = Object.assign([], props.workstation.restrictions);
        let index = tempRestrictions.indexOf(tempRestrictions.find(x => x.id === restrictionId))
        tempRestrictions.splice(index, 1)
        props.actions.setRestrictions(tempRestrictions)
        setDialogOpen(false)
    }

    function openDialogDeleteRestriction(id) {
        setDialogTitle("Deleting Restriction")
        setDialogContext("Are you sure deleting this restriction?")
        setRestrictionId(id)
        setDialogOpen(true)
    }

    function closeDialog() {
        setDialogOpen(false)
    }

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.openDrawer(false)} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>Workstation restrictions</div>
                <button className={classes.addButton} onClick={() => props.openCreateEditRestrictionDrawer(true, null)}>
                    <div className={classes.AddIconContainer}><AddIcon></AddIcon></div>
                    <div className={classes.addRestriction}>Add restriction</div>
                </button>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}><CloseIcon></CloseIcon></Button>
                </div>
            </div>
            <div className={classes.body}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.headCell}>Production line</TableCell>
                            <TableCell className={classes.headCell}>Start</TableCell>
                            <TableCell className={classes.headCell}>End</TableCell>
                            <TableCell className={classes.headCell}>Type</TableCell>
                            <TableCell className={classes.headCell}></TableCell>
                            <TableCell className={classes.headCell}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.deleteId} className={classes.row}>
                                <TableCell className={classes.infoCell}>{row.workstation}</TableCell>
                                <TableCell className={classes.infoCell}>{row.start}</TableCell>
                                <TableCell className={classes.infoCell}>{row.end}</TableCell>
                                <TableCell className={classes.infoCell} style={{ color: row.typeColor, textTransform: "uppercase" }}>{row.typeDescription}</TableCell>
                                <TableCell className={classes.infoCell}><button className={classes.editButton} onClick={() => props.openCreateEditRestrictionDrawer(true, row.editId)}><img className={classes.editIcon} alt="pencil" src={process.env.PUBLIC_URL + '/img/pencil.svg'}></img></button></TableCell>
                                <TableCell className={classes.infoCell} style={{ color: row.stockColor }}><button className={classes.deleteButton} onClick={() => openDialogDeleteRestriction(row.deleteId)}><DeleteIcon className={classes.deleteIcon}></DeleteIcon></button></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
            <DeleteDialog {...props} dialogOpen={dialogOpen} action={deleteRestriction} closeDialog={closeDialog} dialogTitle={dialogTitle} dialogContext={dialogContext}></DeleteDialog>
        </div>
    </Drawer >
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        padding: "20px",
        paddingRight: "15px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    drawerOpen: {
        width: "40%",
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "10%",
        float: 'left',
    },
    title: {
        float: 'left',
        width: "50%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px"
    },

    header: {
        width: "100%",
        height: "5%",
        marginBottom: "40px"
    },
    infoCell: {
        padding: "10px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "white",
        },
    },
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        padding: "3px",
        paddingTop: "0px",
        border: "none",
    },
    editButton: {
        border: "none",
        outline: 'none',
        backgroundColor: "rgb(1,1,1,0.0)",
        cursor: "pointer"
    },
    deleteButton: {
        border: "none",
        outline: 'none',
        backgroundColor: "rgb(1,1,1,0.0)",
        cursor: "pointer"
    },
    deleteIcon: {
        height: "25px",
        width: "25px",
        color: FlagstoneTheme.palette.primary.main,
    },   
    AddIconContainer: {
        float: "left",
        color: FlagstoneTheme.palette.primary.main,

    },
    addRestriction: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: FlagstoneTheme.palette.primary.main,
        float: "left",
        paddingTop:"3px"
    },
    addButton: {
        outline: 'none',
        border: "none",
        cursor: "pointer",
        float: "left",
        width:"40%",
        paddingTop:"20px" ,
        paddingLeft:"150px"    
    }
}));